<template>
  <div class="bg_index">
    <productBanner :Product="product2" class="bannerFather2"></productBanner>

    <!-- 技术亮点 -->
    <div class="w100 hxjs">
      <div class="other">
        <div v-for="(item,index) in cardMsg" :key="index">
          <coreCard :cardMsg="item"></coreCard>
        </div>
      </div>
    </div>

    <!-- 使用场景 -->
    <suitCase :list="suit2" class="suitcase2"></suitCase>

    <div style="background-color: white;">
      <!-- 下载彩页 -->
      <productDownload :product="download"></productDownload>
    </div>
    <!-- 商务合作 -->
    <cooperateForm class="submitform" id="submit"></cooperateForm>
    <div class="footblack" />
  </div>
</template>

<script>
import cooperateForm from '@/components/common/cooperateForm'
import suitCase from '@/components/common/suitCase'
import TechnicalHighlights from '@/components/common/TechnicalHighlights'
import productBanner from '@/components/common/productBanner'
import coreCard from '@/components/common/coreCard'
import productDownload from '@/components/common/productDownload'
// import { BaseURL } from '@/api/http.js'
export default {
  data () {
    return {
      download: '彩页图',
      product2: {
        'background': 'images/hs/hs_banner_bg_1.png',
        'img': 'images/chanpin/hs_bang.png',
        'h2': ['音频数据智能分析系统'],
        'desc': ['面向海量音频数据筛查与分析任务场景的', '智能分析平台及配套工具集'],
        'h3': [],
        'p': ['系列—语音刻画家', '声纹辨认与音频大数据分析'],
        'product': 'images/chanpin/sj.png'
      },
      cardMsg: [{
        'img': 'images/hs/hs_js_10.png',
        'h3': '大幅降低人工工作量',
        'p': [],
        'li': [
          '面向任务的工作流编排和工作流自动化执行;', '特征标记与音频数据结构化;']
      }, {
        'img': 'images/hs/hs_js_11.png',
        'h3': '贴近实战',
        'p': [],
        'li': [
          '在高噪声、低信噪比具备高识别率；',
          '支持跨信道、跨语言识别同一目标人；', '支持会议、密谈等多人说话音频场景下的目标人跟踪注册与识别；',
          '支持近二十种普通或特殊信道环境的音频搜索分析;']
      }, {
        'img': 'images/hs/hs_js_12.png',
        'h3': '一站式解决方案',
        'p': [],
        'li': [
          '集成了丰富的音频大数据工具，智能化程度高;']
      }],
      suit2: [
        { 'img': 'images/hs/hs_cj_1.png', 'context': ['国防与公共安全情报分析'] },
        { 'img': 'images/hs/hs_cj_2.png', 'context': ['政企机构的客服录音数据分析与审查'] },
        { 'img': 'images/hs/hs_cj_3.png', 'context': ['智能安防领域中的音频监控'] }
      ]
    }
  },
  methods: {
  },
  components: {
    cooperateForm: cooperateForm,
    TechnicalHighlights,
    suitCase: suitCase,
    productBanner,
    coreCard,
    productDownload
  }
}
</script>

<style scoped>
/* 技术优势 */
.Technical {
  background-color: white;
}

.submitform {
  width: 803px;
  margin-top: 75px;
  margin-bottom: -23px;
}

.footblack {
  height: 50px;
  width: 100%;
  background: rgba(248, 248, 248, 1);
}
/* 产品亮点 */
.other {
  margin: 0 auto;
  width: 1250px;
  height: 650px;
}
.other > div {
  float: left;
  margin-left: 38px;
  margin-top: 35px;
}
.other /deep/ .app {
  height: 520px;
}
.other /deep/ .title {
  height: 290px;
}
.other /deep/ .context .item-core :nth-child(2) {
  width: 280px;
}
.suitcase /deep/ .cjapply {
  width: 526px;
}
.suitcase2 /deep/ .cjapply {
  width: 366px;
}
.suitcase2 /deep/ #cj {
  width: 1200px;
}
.bannerFather2 /deep/ .container {
  padding-top: 100px;
}
.bannerFather2 /deep/ .caiye {
  margin-top: 50px;
}
.bannerFather2 /deep/ .float {
  margin-top: 40px !important ;
}
.bannerFather2 /deep/ img {
  margin-top: 55px !important;
}
.bannerFather2 /deep/ .product-p {
  margin-top: 150px;
}
.bannerFather2 /deep/ .desc {
  margin-top: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/solution/Hs/SoundScriber.vue